export const parseValue = value => {
  const type = typeof value
  if (['undefined', null].includes[type]) return '-'
  if (type === 'number') return parseInt(value, 10)

  return value
}
